import {Button} from 'react-bootstrap';

const FallBackComponent = () => (
	<div className="total-center text-center">
		<h1 className="display-1 fw-bold">Opps!</h1>
		<p className="fs-3"> An error has occurred.</p>
		<p className="lead">Please try again.</p>
		<Button
			className="btn btn-primary"
			onClick={() => (window.location.href = '/dashboard')}>
			Go Dashboard
		</Button>
	</div>
);

export default FallBackComponent;
